export default __webpack_public_path__ + "static/bentoSectionBg5-1d0629c673a90ce546d5008bf69b5bbc.webp";